import React from "react"
import { Link, StaticQuery } from "gatsby";
import Img from "gatsby-image"
import styled from "@emotion/styled";
import {Logo} from "../components/logo"
import Container from "./container";
import theme from "../theme";
import {
  FaInstagram,
  FaFacebook,
} from "react-icons/fa"
import {
  Heading,
  Box,
  Grid,
  Link as ChakraLink,
  List,
  ListItem,
  SimpleGrid, 
  PseudoBox,
} from "@chakra-ui/core";

const Styles = styled.footer`
`
export default class Footer extends React.Component {
  render() {
    return (
      <Styles>
        <Box bg="gray.100" color="gray.900" borderTopWidth="1px" borderColor="gray.900">

          <Container>
            <SimpleGrid columns={[1, 2, 2, 4]} spacing={8} mt={6} mb={6}>


            <Box>

<Heading size="sm" mb={2} textAlign={["center", "left"]}>
  Customer Service
</Heading>

<List styleType={["none", "disc"]} textAlign={["center", "left"]}>
  <ListItem>
    <ChakraLink as={Link} to="contact" rounded="sm">
      Contact
  </ChakraLink>
  </ListItem>

  <ListItem>
    <ChakraLink as={Link} to="returns" rounded="sm">
      Returns
  </ChakraLink>
  </ListItem>

  <ListItem>
    <ChakraLink as={Link} to="privacy-policy" rounded="sm">
      Privacy Policy
  </ChakraLink>
  </ListItem>
  <ListItem>
    <ChakraLink as={Link} to="terms-and-conditions" rounded="sm">
      Terms & Conditions
  </ChakraLink>
  </ListItem>

</List>
</Box>


              <Box>

                <Heading size="sm" mb={2} textAlign={["center", "left"]}>
                  Site Map
                </Heading>
                <List styleType={["none", "disc"]} textAlign={["center", "left"]}>


                  <ListItem>
                    <ChakraLink as={Link} to="about" rounded="sm">
                      About
                  </ChakraLink>
                  </ListItem>

                  <ListItem>
                    <ChakraLink as={Link} to="catalog" rounded="sm">
                      Catalog
                      </ChakraLink>
                  </ListItem>

                  <ListItem>
                    <ChakraLink as={Link} to="shop" rounded="sm">
                      Shop
                      </ChakraLink>
                  </ListItem>

                  <ListItem>
                    <ChakraLink as={Link} to="subscribe" rounded="sm">
                      Subscribe
                  </ChakraLink>
                  </ListItem>


                  <ListItem>
                    <ChakraLink as={Link} to="blog" rounded="sm">
                      Blog
                  </ChakraLink>
                  </ListItem>


             

                


                </List>
              </Box>



              <Box>

                <Heading size="sm" mb={2} textAlign={["center", "left"]}>
                  Connect With Us!
                </Heading>

                <Socials />
              </Box>

              <Box>
                <Box textAlign={["center", "left", "left",  "right"]}>
                  <Box width="80px" display="inline-block">
                  <Link to="/">
                  <Logo />
                  </Link>
                  </Box>

                </Box>
              </Box>

            </SimpleGrid>

            <Box textAlign="center">
              © {new Date().getFullYear()},
          {` `}
              <ChakraLink as={Link} to="/">Prolific Coast Seeds</ChakraLink>
            </Box>

          </Container>
        </Box>
      </Styles>
    )
  }
}



export const Socials = () => (
  <StaticQuery
    query={graphql`
    {
      facebook: file(relativePath: {eq: "facebook.png"}) {
        id
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      instagram: file(relativePath: {eq: "instagram.png"}) {
        id
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      twitter: file(relativePath: {eq: "twitter.png"}) {
        id
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      snapchat: file(relativePath: {eq: "snapchat.png"}) {
        id
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      tiktok: file(relativePath: {eq: "tiktok.png"}) {
        id
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      
    }
    `}
    render={data => (
      <Grid templateColumns="repeat(auto-fit, 30px)" gap={5} justifyContent={["center", "left"]}>

        <PseudoBox fontSize="23px" textAlign="center" cursor="pointer" _hover={{ transform: "scale(1.05)", color: theme.blue }} transition="all 0.1s ease" >
          <a href="https://www.facebook.com/pages/category/Product-Service/Prolific-Coast-Seeds-1499360206810281/" target="_blank" rel='noopener noreferrer'>
            <FaFacebook />

          </a>
        </PseudoBox>

        <PseudoBox fontSize="23px" textAlign="center" cursor="pointer" _hover={{ transform: "scale(1.05)", color: theme.blue }} transition="all 0.1s ease" >
          <a href="https://www.instagram.com/prolificcoastseed/" target="_blank" rel='noopener noreferrer'>
            <FaInstagram />

          </a>
        </PseudoBox>


      </Grid>
    )}
  />
)
